import React from 'react';
import Dropzone from 'react-dropzone';

import { Trash } from 'lucide-react';
import { Button, DefaultTooltip, Thumbnail } from 'twyne-new.ui'

const FileUpload = ({ onUpload, value, isLoading, onRemove, type = 'image' }) => <div className='relative'>
  <Dropzone
    multiple={false}
    accept={type === 'image' ? "image/*" : !type ? null : type}
    onDrop={files => {
      console.log(files, type)

      return onUpload(files[0])
    }}
    style={{}}
    disabled={isLoading}
  >
    <Thumbnail
      value={value?.name || value}
      size='lg'
      loading={isLoading}
      type={type}
    />
  </Dropzone>
  {value ? <div className="flex justify-between mt-2">
    {type === 'image' && <div className='font-bold'>{formatImageName(Array.isArray(value) ? value[0] : value)}</div>}
    <Button
      className='absolute top-1 right-0'
      variant='ghost'
      size='sm'
      color='danger'
      onClick={onRemove}>
      <Trash size={14} />
    </Button>
  </div> : null}
</div>

const formatImageName = name => {
  if (!name) {
    return ''
  }

  const lastDotIndex = name.lastIndexOf('.')
  if (lastDotIndex === -1) {
    return name
  }

  const extension = name.slice(lastDotIndex)
  const nameWithoutExt = name.slice(0, lastDotIndex)

  if (nameWithoutExt.length <= 10) {
    return name
  }

  return <>
    <DefaultTooltip content={name}>
      {nameWithoutExt.slice(0, 10)}(...){extension}
    </DefaultTooltip>
  </>
}

export default FileUpload;
